import FiltrosListaObjetosConIds from "../tipos/filtrosListaObjetosConId"
import TypesUtils from "../../utils/typesUtils"
import { TRISTATE_CUALQUIERA } from "../../utils/triStateUtils";

class FiltroEstaciones extends FiltrosListaObjetosConIds {
  /**
   *
   * @param {String[]} gerencias
   * @param {number} automaticas 0: ninguna automaticas, 1: solo automaticas, 2: cualquiera
   * @param {number} convencionales 0: ninguna convencional, 1: solo convencionales, 2: cualquiera
   * @param {number} aeronauticas 0: ninguna convencional, 1: solo convencionales, 2: cualquiera
   */
  constructor(gerencias, automaticas, convencionales, aeronauticas) {
    super();
    this.gerencias = gerencias;
    this.automaticas = TypesUtils.getValueOrDefault(automaticas,TRISTATE_CUALQUIERA);
    this.convencionales = TypesUtils.getValueOrDefault(convencionales,TRISTATE_CUALQUIERA);
    this.aeronauticas = TypesUtils.getValueOrDefault(aeronauticas,TRISTATE_CUALQUIERA);
  }

  equals(filtro) {
    return (
      filtro &&
      filtro.equalsContents(filtro.gerencias, this.gerencias) &&
      filtro.automaticas === this.automaticas &&
      filtro.convencionales === this.convencionales &&
      filtro.aeronauticas === this.aeronauticas
    );
  }
}

export { FiltroEstaciones as default };
